import { render, staticRenderFns } from "./ContactBox.vue?vue&type=template&id=974ce6fa&scoped=true&"
import script from "./ContactBox.vue?vue&type=script&lang=js&"
export * from "./ContactBox.vue?vue&type=script&lang=js&"
import style0 from "./ContactBox.vue?vue&type=style&index=0&id=974ce6fa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "974ce6fa",
  null
  
)

export default component.exports